export enum VariationType {
  DIRECT_TRANSLATION = 'Direct translation',
  REWRITE_REPHRASE = 'Rewrite/Rephrase',
}

export enum VariationLength {
  SUMMARY = 'Summary',
  FULL_PIECE = 'Full Piece',
}

export enum VariationHeadline {
  REGULAR = 'Regular title',
  CLICKBAIT = 'Clickbait title',
}

export enum Structure {
  HTML_WITH_BLOCKS = 'HTML (with BC blocks)',
  HTML_WITHOUT_BLOCKS = 'HTML (without BC blocks)',
  PLAIN_TEXT = 'Plain Text' 
}